<template>
  <div id="centreRight3">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span style="color: #5cd9e8">
          <i class="iconfont iconliuliang"></i>
        </span>
        <span class="fs-xl text mx-2">今日进出流量</span>
      </div>
      <div class="d-flex jc-center">
        <Echart
          :options="options"
          id="centreRight3"
          height="100%"
          width="100%"
        ></Echart>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from "@/common/echart";

export default {
  data() {
    return {
      options: {},
      parkIn:[], // 入场车辆
      parkOut:[]  // 出场车辆
    };
  },
  components: {
    Echart,
  },
  mounted() {
    this.newEcharts();
  },
  methods: {
    newEcharts(){
      this.options = {
        title: {
          text: "",
        },
        grid: {
          top:"5%",
          left: "-5%",
          right: "4%",
          bottom: "5%",
          containLabel: true,
        },
        tooltip: {
          show: "true",
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        yAxis: {
          type: "value",
          show:false,
          position:'left',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
            },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#0d1223",
              },
            },
            data: ["临时车", "月租车", "储值车"],
          },
          {
            type: "category",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            data: ["临时车", "月租车", "储值车"],
          },
        ],
        series: [{
            name: "入场",
            type: "bar",
            itemStyle: {
              normal: {
                show: true,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#00FFE6",
                    },
                    {
                      offset: 1,
                      color: "#007CC6",
                    },
                  ],
                  global: false, //  缺省为  false
                },
                barBorderRadius: 5,
                borderWidth: 0,
                borderColor: "#333",
              },
            },
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  color: "#fff",
                },
              },
            },
            barGap: "200%",
            barWidth: "15%",
            data: this.parkIn,
          },
          {
            name: "出场",
            type: "bar",
            barWidth: "15%",
            itemStyle: {
              normal: {
                show: true,
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3023AE",
                    },
                    {
                      offset: 1,
                      color: "#C96DD8",
                    },
                  ],
                  global: false, //  缺省为  false
                },
                barBorderRadius: 5,
                borderWidth: 0,
                borderColor: "#333",
              },
            },
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  color: "#fff",
                },
              },
            },
            barGap: "200%",
            data: this.parkOut,
          },
        ],
      };
    },
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.reailTimeToal"(val) {
      //变化之后根据自己项目需求写自身的逻辑代码，下面只是示例
      var parkIn = [];
      var parkOut = [];
      parkIn.push(val.tempInCount+30000);
      parkIn.push(val.monthInCount+35000);
      parkIn.push(val.storeInCount+7000);
      parkOut.push(val.tempOutCount+20000);
      parkOut.push(val.monthOutCount+22000);
      parkOut.push(val.storeOutCount+6000);
      this.parkIn = parkIn;
      this.parkOut = parkOut;
      this.newEcharts();
    },
  },
};
</script>

<style lang="scss">
#centreRight3 {
  height: 100%;
  border-radius: 0.0625rem;
  .bg-color-black {
    height: 5.0625rem;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .jc-center {
    height: 85%;
  }
}
</style>